// String constants mirroring `MeetingEventTimestampDataType` in @govinity/validation. Kept as local
// literals (rather than importing the enum) so this helper stays dependency-light and safe to import
// from broadly-included modules — matching how the search-index builder references these values.
const AGENDA_SECTION = 'agenda_section';
const AGENDA_SECTION_ITEM = 'agenda_section_item';
/**
 * Resolves the display title for an agenda-linked timestamp, shared by the public portal media-index
 * view and the search-index builder so they never diverge. Agenda section/item rows resolve through
 * the title lookups (keyed the same way the timestamp `dataId` is — placement id for items, section
 * id for sections), falling back to the timestamp's own `label`. Any other data type returns the
 * `label` verbatim (`null` for minute-record rows that carry none). Returns `null` when nothing
 * resolves — the caller drops such rows.
 */
export const resolveAgendaTimestampLabel = ({ dataType, dataId, label }, { sectionTitleById, itemTitleById }) => {
    if (dataType === AGENDA_SECTION) {
        return (dataId !== null ? (sectionTitleById.get(dataId) ?? null) : null) ?? label;
    }
    if (dataType === AGENDA_SECTION_ITEM) {
        return (dataId !== null ? (itemTitleById.get(dataId) ?? null) : null) ?? label;
    }
    return label;
};
/**
 * Resolves the agenda anchor (`dataType`/`dataId`) an entry-level timestamp belongs to, from its
 * linked minutes entry. Item entries anchor to their placement (`AgendaSectionLegislativeItem.id`),
 * section entries to their `AgendaSection.id`. Returns `null` for floor entries (quick-add /
 * duplicate) that carry no agenda linkage — those keep their own label instead.
 */
export const resolveEntryTimestampAnchor = (entry) => {
    if (entry.agendaSectionItemId !== null) {
        return { dataType: AGENDA_SECTION_ITEM, dataId: entry.agendaSectionItemId };
    }
    if (entry.agendaSectionId !== null) {
        return { dataType: AGENDA_SECTION, dataId: entry.agendaSectionId };
    }
    return null;
};
